import type React from "react";

export interface InfoCardItem {
	label: string;
	text: string;
}

interface InfoCardProps {
	imageSrc: string;
	title: string;
	subtitle?: string;
	items: InfoCardItem[];
}

export const InfoCard: React.FC<InfoCardProps> = ({
	imageSrc,
	title,
	subtitle,
	items,
}) => {
	return (
		<div className="w-full bg-white border border-color_border_grey_1 rounded-[8px] overflow-hidden shrink-0 snap-center flex flex-col">
			<div className="h-[150px] w-full relative shrink-0">
				<img
					src={imageSrc}
					className="absolute inset-0 w-full h-full object-cover pointer-events-none"
					alt=""
				/>
			</div>

			<div className="pt-[20px] pb-[40px] px-[20px] flex flex-col items-start justify-start flex-1">
				<p className="font-medium text-[16px] leading-[1.35] text-color_text_grey_5 w-full">
					{title}
				</p>

				{subtitle && (
					<p className="font-normal text-[14px] leading-[1.4] tracking-[0.25px] text-color_text_grey_4 w-full">
						{subtitle}
					</p>
				)}

				<ol className="mt-4 flex flex-col w-full list-decimal list-outside ml-[18px]">
					{items.map((item, idx) => (
						<li
							key={idx}
							className="font-normal text-[14px] leading-[1.4] tracking-[0.25px] text-color_text_grey_4"
						>
							<span>{item.label}:</span> {item.text}
						</li>
					))}
				</ol>
			</div>
		</div>
	);
};
